import styled, { css } from "styled-components";
import tokens from "../../theme/tokens";

const sizeStyles = {
  sm: css`
    font-size: 11px;
    line-height: 1;
    padding: 3px 8px;
    height: 20px;
  `,
  md: css`
    font-size: 12px;
    line-height: 1;
    padding: 5px 10px;
    height: 24px;
  `,
};

const variantStyles = {
  ready: css`
    color: ${tokens.status.ready.fg};
    background: ${tokens.status.ready.bg};
    border-color: ${tokens.status.ready.border};
  `,
  processing: css`
    color: ${tokens.status.processing.fg};
    background: ${tokens.status.processing.bg};
    border-color: ${tokens.status.processing.border};
  `,
  review: css`
    color: ${tokens.status.review.fg};
    background: ${tokens.status.review.bg};
    border-color: ${tokens.status.review.border};
  `,
  failed: css`
    color: ${tokens.status.failed.fg};
    background: ${tokens.status.failed.bg};
    border-color: ${tokens.status.failed.border};
  `,
  open: css`
    color: ${tokens.status.ready.fg};
    background: ${tokens.status.ready.bg};
    border-color: ${tokens.status.ready.border};
  `,
  closed: css`
    color: ${tokens.status.closed.fg};
    background: ${tokens.status.closed.bg};
    border-color: ${tokens.status.closed.border};
  `,
};

export const ChipRoot = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 1px solid transparent;
  border-radius: 9999px;
  font-family: ${tokens.typography.fontFamily};
  font-weight: ${tokens.typography.weight.semibold};
  letter-spacing: 0.01em;
  white-space: nowrap;
  vertical-align: middle;

  ${(p) => sizeStyles[p.$size] || sizeStyles.sm}
  ${(p) => variantStyles[p.$variant] || variantStyles.ready}

  ${(p) =>
    p.$interactive &&
    css`
      cursor: pointer;
      appearance: none;
      outline: none;

      &:hover {
        filter: brightness(0.96);
      }
      &:focus-visible {
        box-shadow: 0 0 0 2px ${tokens.brand.primaryLight};
      }
    `}
`;
